import { Country, EnumSchema, Executor, FromSchema } from '@40seas/entities/common';
import { BaseEntity, WithBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';
import { CreditSafePortfolioEventRuleStatus } from './credit-safe-portfolio.event-rule.status';

export const CreditSafePortfolioEventRuleSchema = WithBaseEntitySchema(
    z.object({
        portfolioId: z.string(),
        status: EnumSchema(CreditSafePortfolioEventRuleStatus),
        ruleCode: z.number(),
        ruleCountry: z.union([z.literal('global'), EnumSchema(Country)]),
        ruleType: z.number(),
        name: z.string(),
        param0: z.string().optional(),
        param1: z.string().optional(),
        param2: z.string().optional(),
    }),
).strict();

export class CreditSafePortfolioEventRule extends FromSchema(CreditSafePortfolioEventRuleSchema) implements BaseEntity {
    id: string;
    portfolioId: string;
    status: CreditSafePortfolioEventRuleStatus;
    ruleCode: number;
    ruleCountry: Country | 'global';
    ruleType: number;
    name: string;
    param0?: string;
    param1?: string;
    param2?: string;
    createdAt: Date;
    updatedAt: Date;
    tenantId: string;
    createdBy?: Executor;
    seller?: string;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}
